import Swal from "sweetalert2";

const simpleAlert = (
  title: string,
  description: string,
  bottonText: string,
  handlerAction: () => void,
) => {
  Swal.fire({
    title,
    text: description,
    confirmButtonText: bottonText,
  }).then(handlerAction);
};

export { simpleAlert };
